import { useTranslation } from "react-i18next";

import PageBox from "../../../../components/box/PageBox";
import RegularContainer from "../../../../components/container/RegularContainer";
import { HeadingWithInfo } from "../../../../components/heading";
import { useSocialContext } from "../../context";
import useChartZoom from "../../hooks/useChartZoom";
import usePieChart from "../../hooks/usePieChart";
import usePieChartZoom from "../../hooks/usePieChartZoom";
import useSocialMessageAnalysis from "../../hooks/useSocialMessageAnalysis";
import useWordCloud from "../../hooks/useWordCloud";
import useWordCloudZoom from "../../hooks/useWordCloudZoom";
import ChartContainer from "../chartContainer/ChartContainer";
import ChartsLayout from "../chartsLayout/ChartsLayout";
import { ChartZoomModal } from "../chartZoom";
import styles from "./SocialMessageAnalysis.module.scss";

const SocialMessageAnalysis = () => {
    const { t } = useTranslation();
    const { category } = useSocialContext();

    // Zoom states
    const pieChartZoom = useChartZoom();
    const wordCloudZoom = useChartZoom();

    const { selectedPieData, selectedWordData } = useSocialMessageAnalysis({ category });

    // Normal charts
    const socialPieChart = usePieChart({
        pieData: selectedPieData,
        category: "",
    });

    const wordCloudChart = useWordCloud({
        wordCloudData: selectedWordData,
        category: "",
    });

    // Zoomed charts - 只在對應的 Modal 打開時才創建
    const socialPieChartZoom = usePieChartZoom({
        pieData: pieChartZoom.isZoomed ? selectedPieData : undefined,
        category: "",
        isZoomed: true,
    });

    const wordCloudChartZoom = useWordCloudZoom({
        wordCloudData: wordCloudZoom.isZoomed ? selectedWordData : undefined,
        category: "",
        isZoomed: true,
    });

    return (
        <RegularContainer sx={{ mt: 0, pt: 0 }}>
            <PageBox hasChatBox={false}>
                <ChartsLayout>
                    <div className={styles.chartContainer}>
                        <HeadingWithInfo
                            title={t("ANALYSIS.Proportion_Lang")}
                            info={t("ANALYSIS.Proportion_Lang_HELP")}
                        />
                        <ChartContainer isBigChart={false} title=' ' onZoomClick={pieChartZoom.openZoom}>
                            <div ref={socialPieChart} style={{ height: "100%", width: "100%" }} />
                        </ChartContainer>
                    </div>
                    <div className={styles.chartContainer}>
                        <HeadingWithInfo title={t("ANALYSIS.Word_Cloud")} info={t("ANALYSIS.Word_Cloud_HELP")} />
                        <ChartContainer isBigChart={false} title=' ' onZoomClick={wordCloudZoom.openZoom}>
                            <div ref={wordCloudChart} style={{ height: "100%", width: "100%" }} />
                        </ChartContainer>
                    </div>
                </ChartsLayout>

                {/* Zoom Modals */}
                {pieChartZoom.isZoomed && (
                    <ChartZoomModal
                        isOpen={pieChartZoom.isZoomed}
                        onClose={pieChartZoom.closeZoom}
                        title='ANALYSIS.Proportion_Lang'
                    >
                        <div ref={socialPieChartZoom} style={{ height: "100%", width: "100%" }} />
                    </ChartZoomModal>
                )}

                {wordCloudZoom.isZoomed && (
                    <ChartZoomModal
                        isOpen={wordCloudZoom.isZoomed}
                        onClose={wordCloudZoom.closeZoom}
                        title='ANALYSIS.Word_Cloud'
                    >
                        <div ref={wordCloudChartZoom} style={{ height: "100%", width: "100%" }} />
                    </ChartZoomModal>
                )}
            </PageBox>
        </RegularContainer>
    );
};
export default SocialMessageAnalysis;
